import React from 'react';
// @ts-ignore
import styles from './Button.module.scss';
import useTranslation from '../../../../../Hooks/useTranslation';
import FirstUpper from '../../FirstUpper';
import { Theme } from '../../../Enums/Theme.enum';

interface Props {
	onClick?: () => void;
	title: string;
	icon?: string;
	subtitle?: string;
	showArrow?: boolean;
	className?: string;
	theme?: Theme;
	badge?: string;
}

const Button: React.FC<Props> = ({
	onClick,
	title,
	icon,
	subtitle,
	showArrow = true,
	className,
	theme,
	badge,
}) => {
	const { t } = useTranslation();
	return (
		<div
			className={[
				styles.button,
				className,
				styles[theme],
				onClick ? styles.clickable : '',
			].join(' ')}
			onClick={onClick}
		>
			{badge && <div className={styles.badge}>{badge}</div>}
			{icon && <img src={icon} className={styles.icon} />}
			<div className={styles.content}>
				<div className={styles.title}>
					<FirstUpper>{t(title)}</FirstUpper>
				</div>
				{subtitle && (
					<div className={styles.subtitle}>
						<FirstUpper>{t(subtitle)}</FirstUpper>
					</div>
				)}
			</div>
			{showArrow && (
				<div className={styles.arrow}>
					<img
						src={
							theme === Theme.GREEN
								? '/dist/patientV3/icons/arrow-right-white-small.svg'
								: '/dist/patientV3/icons/arrow-right-purple-small.svg'
						}
					/>
				</div>
			)}
		</div>
	);
};

export default Button;
